module.exports = __webpack_public_path__ + "static/media/front-desk-pro-tip-refferal-source.a08cd345.png";